/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/style/admin.style.scss */
/*# sourceMappingURL=admin.style.css.map */
